module.exports = __webpack_public_path__ + "assets/img/join2021_008.ae635e42.png";